import { render, staticRenderFns } from "./SearchContextSelectionComponent.vue?vue&type=template&id=774b2fdb&scoped=true&"
import script from "./SearchContextSelectionComponent.vue?vue&type=script&lang=ts&"
export * from "./SearchContextSelectionComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774b2fdb",
  null
  
)

export default component.exports